import { BILLING_TYPE, FP_BILLING_TYPE, TM_BILLING_TYPE } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const billingTypeRequest = (url, method, payload) => ({
  url,
  method,
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload ? { payload } : {}),
  service: serviceName.MASTER_MS,
});

export const getFpBillingTypes = () => billingTypeRequest(
  `${FP_BILLING_TYPE}?cb=${Date.now()}`,
  'get',
);

export const getTmBillingTypes = () => billingTypeRequest(
  `${TM_BILLING_TYPE}?cb=${Date.now()}`,
  'get',
);

export const getBillingTypes = () => billingTypeRequest(
  `${BILLING_TYPE}?cb=${Date.now()}`,
  'get',
);

// Note: FpBillingType/TmBillingType Sequelize models expose generic
// attribute names ("name", "is_active") mapped to fp_bil_type/tm_bil_type columns.
export const createFpBillingType = (billingTypeName) => billingTypeRequest(
  FP_BILLING_TYPE,
  'post',
  { name: billingTypeName },
);

export const createTmBillingType = (billingTypeName) => billingTypeRequest(
  TM_BILLING_TYPE,
  'post',
  { name: billingTypeName },
);

export const updateFpBillingType = (id, billingTypeName, isActive) => billingTypeRequest(
  `${FP_BILLING_TYPE}/${id}`,
  'put',
  { name: billingTypeName, is_active: isActive },
);

export const updateTmBillingType = (id, billingTypeName, isActive) => billingTypeRequest(
  `${TM_BILLING_TYPE}/${id}`,
  'put',
  { name: billingTypeName, is_active: isActive },
);
